import { isBefore, parseISO } from 'date-fns';
import type { Period, Task } from 'fhir/r4';

import {
  createFhirDate,
  ExtensionUrl,
  filterExtensions,
  type PeriodComplete,
} from '../mapping';
import type { WithId } from '../types';

export const setTaskOverdue = (tasks: WithId<Task>[]): WithId<Task>[] =>
  tasks.map((item) => ({ ...item, status: 'failed' }));

export const isPeriodComplete = (period: Period): period is PeriodComplete =>
  (period as PeriodComplete).end !== undefined;

export const createPeriod = (start: Date, end: Date): PeriodComplete => ({
  start: createFhirDate(start),
  end: createFhirDate(end),
});

export const filterByRequestedPeriod = (
  tasks: WithId<Task>[],
): WithId<Task>[] | undefined =>
  tasks.filter((fhirTask) => {
    const requestedPeriodExtensions = filterExtensions(
      ExtensionUrl.TaskRequestedPeriod,
      fhirTask.extension,
    );

    const extensionReferences = requestedPeriodExtensions.map(
      (ext) => ext.valuePeriod,
    );
    const requestedPeriod = extensionReferences[0];

    if (
      !requestedPeriod ||
      !isPeriodComplete(requestedPeriod) ||
      !isBefore(parseISO(requestedPeriod.end), new Date())
    ) {
      return undefined;
    }

    return fhirTask;
  });
